import { userService } from '../_services'
import router from '../router'

const user = JSON.parse(localStorage.getItem('user'))
const state = user !== undefined
  ? { status: { loggedIn: true }, user }
  : { status: {}, user: null }

const actions = {
  login ({ dispatch, commit }, { username, password }) {
    dispatch('alert/default', 'Espere, conectando...', { root: true })

    commit('loginRequest', { username })

    userService.login(username, password)
      .then(
        user => {
          commit('loginSuccess', user)
          router.push('/')
        },
        error => {
          commit('loginFailure', error)
          if (error === 'Unauthorized') error = 'Acceso no autorizado'
          dispatch('alert/error', { text: error.message, data: error }, { root: true })
          // dispatch('alert/error', error.message, { root: true });
        }
      )
  },
  logout ({ commit }) {
    // console.log('action logout');
    userService.logout()
    commit('logout')
    router.push('/login')
  },
  register ({ dispatch, commit }, user) {
    commit('registerRequest', user)

    userService.register(user)
      .then(
        user => {
          commit('registerSuccess', user)
          router.push('/login')
          setTimeout(() => {
            // display success message after route change completes
            dispatch('alert/success', 'Registration successful', { root: true })
          })
        },
        error => {
          commit('registerFailure', error)
          dispatch('alert/error', error, { root: true })
        }
      )
  }
}

const mutations = {
  loginRequest (state, user) {
    // console.log('mutation loginRequest');
    state.status = { loggingIn: true }
    state.user = user
  },
  loginSuccess (state, user) {
    // console.log('mutation loginSuccess');
    state.status = { loggedIn: true }
    state.user = user
  },
  loginFailure (state) {
    // console.log('mutation loginFailure');
    state.status = { logginError: 401 }
    state.user = null
  },
  logout (state) {
    // console.log('mutation logout');
    state.status = {}
    state.user = null
  },
  registerRequest (state, user) {
    state.status = { registering: true }
  },
  registerSuccess (state, user) {
    state.status = {}
  },
  registerFailure (state, error) {
    state.status = {}
  }
}

export const account = {
  namespaced: true,
  state,
  actions,
  mutations
}
